import { call, put, takeEvery } from 'redux-saga/effects';
import * as actions from './_actions';
import * as types from './_actionTypes';

function* fetchAssessmentsSaga() {
  try {
    const mockAssessments = [
      {
        id: 1,
        title: 'Mid-term Assessment',
        type: 'midterm',
        subject: 'Computer Science',
        questions: 15,
        timeLimit: 2700, // 45 minutes
        attempts: 0,
        maxAttempts: 2,
        passingScore: 50,
        isAvailable: true,
        startDate: '2024-01-20T00:00:00Z',
        endDate: '2024-01-25T23:59:59Z',
        weightage: 30
      },
      {
        id: 2,
        title: 'Final Assessment',
        type: 'final',
        subject: 'Computer Science',
        questions: 25,
        timeLimit: 3600, // 60 minutes
        attempts: 0,
        maxAttempts: 1,
        passingScore: 60,
        isAvailable: false,
        startDate: '2024-02-15T00:00:00Z',
        endDate: '2024-02-20T23:59:59Z',
        weightage: 50
      }
    ];
    
    yield put(actions.fetchAssessmentsSuccess(mockAssessments));
  } catch (error) {
    yield put(actions.fetchAssessmentsFailure(error.message));
  }
}

function* startAssessmentSaga(action) {
  try {
    const mockAssessmentData = {
      id: action.payload,
      title: 'Mid-term Assessment',
      timeLimit: 2700,
      questions: [
        {
          id: 1,
          question: 'Explain the concept of Object-Oriented Programming and its key principles.',
          type: 'essay',
          maxWords: 200
        },
        {
          id: 2,
          question: 'What is the difference between a stack and a queue data structure?',
          options: [
            'Stack is FIFO, Queue is LIFO',
            'Stack is LIFO, Queue is FIFO', 
            'Both are FIFO',
            'Both are LIFO'
          ],
          type: 'mcq',
          correct: 1
        },
        {
          id: 3,
          question: 'Write a function to find the factorial of a number.',
          type: 'code',
          language: 'javascript'
        }
      ]
    };
    
    yield put(actions.startAssessmentSuccess(mockAssessmentData));
  } catch (error) {
    yield put(actions.startAssessmentFailure(error.message));
  }
}

function* submitAssessmentSaga(action) {
  try {
    yield new Promise(resolve => setTimeout(resolve, 2000));
    
    const { assessmentId, answers } = action.payload;
    
    // Mock grading (simplified)
    const score = Math.floor(Math.random() * 30) + 60; // 60-90%
    const result = {
      assessmentId,
      score,
      passed: score >= 50,
      submittedAt: new Date().toISOString(),
      title: 'Mid-term Assessment',
      type: 'midterm',
      feedback: 'Good understanding of concepts. Work on code optimization.'
    };
    
    yield put(actions.submitAssessmentSuccess(result));
  } catch (error) {
    yield put(actions.submitAssessmentFailure(error.message));
  }
}

function* fetchAssessmentResultsSaga() {
  try {
    const mockResults = [
      {
        id: 1,
        assessmentId: 1,
        title: 'Mid-term Assessment',
        type: 'midterm',
        score: 78,
        passed: true,
        submittedAt: '2024-01-22T15:30:00Z',
        feedback: 'Excellent work on theoretical concepts. Code implementation needs improvement.'
      }
    ];
    
    yield put(actions.fetchAssessmentResultsSuccess(mockResults));
  } catch (error) {
    yield put(actions.fetchAssessmentResultsFailure(error.message));
  }
}

function* studentAssessmentsSaga() {
  yield takeEvery(types.FETCH_ASSESSMENTS_REQUEST, fetchAssessmentsSaga);
  yield takeEvery(types.START_ASSESSMENT_REQUEST, startAssessmentSaga);
  yield takeEvery(types.SUBMIT_ASSESSMENT_REQUEST, submitAssessmentSaga);
  yield takeEvery(types.FETCH_ASSESSMENT_RESULTS_REQUEST, fetchAssessmentResultsSaga);
}

export default studentAssessmentsSaga;